/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: api\aiAgentsCallsService.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the AI Integration module.
────────────────────────────────────────────────────────────────*/


import { buildApiUrl, getApiHeaders } from '../../../config/api';
import { AiAgentCall, AiAgentTranscript, GeneratePromptInput } from './aiAgentsTypes';

const BASE_PATH = '/api/telephony/ai-agents';

export async function getAiAgentCalls(agentId: number | string, params?: {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
}): Promise<{ data: AiAgentCall[]; meta: { total: number } }> {
    const q = new URLSearchParams();
    q.append('agentId', agentId.toString());
    if (params?.page) q.append('page', params.page.toString());
    if (params?.limit) q.append('limit', params.limit.toString());
    if (params?.sortBy) q.append('sortBy', params.sortBy);
    if (params?.sortOrder) q.append('sortOrder', params.sortOrder);
    const res = await fetch(`${buildApiUrl(`${BASE_PATH}/calls`)}?${q}`, { method: 'GET', headers: getApiHeaders() });
    if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
    return res.json();
}

export async function getCallTranscripts(callId: number): Promise<AiAgentTranscript[]> {
    const res = await fetch(buildApiUrl(`${BASE_PATH}/calls/${callId}/transcripts`), { method: 'GET', headers: getApiHeaders() });
    if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
    return res.json();
}

export async function generatePrompt(input: GeneratePromptInput): Promise<{ generatedPrompt: string }> {
    const res = await fetch(buildApiUrl(`${BASE_PATH}/generate-prompt`), { method: 'POST', headers: getApiHeaders(), body: JSON.stringify(input) });
    if (!res.ok) { const e = await res.json().catch(() => ({ error: res.statusText })); throw new Error(e.error || `HTTP ${res.status}`); }
    return res.json();
}
